export default "__VITE_ASSET__f0x96RZg__"